// @systeme: contrat
// Inviter quelqu'un dans son foyer : un lien secret envoyé par courriel, valable quelques
// jours. La personne invitée crée son compte (ou se connecte) et rejoint l'espace.
import { z } from 'zod';
import { SchemaRoleMembre } from '../enumerations.js';
import { SchemaElement, SchemaInstant } from './elements.js';
const SchemaEmail = z
    .string()
    .trim()
    .toLowerCase()
    .pipe(z.email({ error: 'Cette adresse ne ressemble pas à un courriel.' }).max(254));
export const SchemaCreationInvitation = z.object({
    email: SchemaEmail,
    role: z.enum(['membre', 'invite']).default('membre'),
});
export const SchemaInvitation = z.object({
    id: z.uuid(),
    email: z.string(),
    role: SchemaRoleMembre,
    /** Le jeton du lien, pour le recopier si le courriel ne part pas. */
    jeton: z.string(),
    expireLe: SchemaInstant,
    accepteeLe: SchemaInstant.nullable(),
    creeLe: SchemaInstant,
});
/** Ce que voit la personne qui ouvre le lien, avant d'avoir un compte : le prénom de qui invite et le nom du foyer. */
export const SchemaInfoInvitation = z.object({
    nomEspace: z.string(),
    prenomInvitante: z.string(),
    email: z.string(),
    valide: z.boolean(),
});
/** Un membre du foyer, tel que les écrans le montrent (pour « qui s'en charge »). */
export const SchemaMembre = z.object({
    id: z.uuid(),
    prenom: z.string(),
    role: SchemaRoleMembre,
});
/** « Qui fait quoi » : seulement les tâches attribuées. Rien n'est calculé sur le reste (DEC-009). */
export const SchemaVueRepartition = z.object({
    attribuees: z.number().int(),
    parMembre: z.array(z.object({ membre: SchemaMembre, elements: z.array(SchemaElement) })),
});
//# sourceMappingURL=invitations.js.map